module.exports = __webpack_public_path__ + "img/-h-红色.3361e574.png";